import React from "react"
import autobind from "class-autobind"
import Records from "../../../components/record/Records"
import { IRecord, IRecordSearch, ERecordSearchFilter, ERecordPageType } from "../../../models"
import * as api from "../../../api"
import * as utils from "../../../helpers/utils"
import UserDetailsRecordReportDialog from "./UserDetailsRecordReportDialog"

interface IProps {
    userId: string
}
interface IState {
    selectedFilter: ERecordSearchFilter
    loading: boolean
    records: IRecord[]
    total: number
    offset: number
    limit: number
    openUserDetailsRecordReportDialog: boolean
}

export default class UserDetailsRecord extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const storedRecordSelectedFilter = utils.getCookie("UserRecordSelectedFilter") as ERecordSearchFilter
        this.state = {
            selectedFilter: storedRecordSelectedFilter || ERecordSearchFilter.All,
            loading: false,
            records: [],
            total: 0,
            offset: 0,
            limit: 20,
            openUserDetailsRecordReportDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getRecords()
    }

    getRecords() {
        this.setState({ loading: true }, () =>
            api.getUserRecords(this.props.userId, this.state.offset, this.state.limit, this.state.selectedFilter).then(res => {
                const result = res.data as IRecordSearch
                this.setState({
                    loading: false,
                    records: result.Documents,
                    total: result.TotalDocumentCount
                })
            })
        )
    }

    render() {
        return (
            <div>
                <Records
                    loading={this.state.loading}
                    pageMode={ERecordPageType.UserDetail}
                    selectedFilter={this.state.selectedFilter}
                    total={this.state.total}
                    offset={this.state.offset}
                    limit={this.state.limit}
                    limitOptions={[20, 50, 100]}
                    records={this.state.records}
                    onPageClick={offset => this.setState({ offset }, () => this.getRecords())}
                    onLimitChange={limit => this.setState({ limit, offset: 0 }, () => this.getRecords())}
                    handleChangeSelectedFilter={selectedFilter => {
                        localStorage.setItem("findd_UserRecordSelectedFilter", selectedFilter)
                        this.setState({ selectedFilter, offset: 0 }, () => this.getRecords())
                    }}
                    reload={initOffset => initOffset ?
                        this.setState({ offset: 0 }, () => this.getRecords()) :
                        this.getRecords()
                    }
                    handleDownload={() => this.setState({ openUserDetailsRecordReportDialog: true })}
                />
                {this.state.openUserDetailsRecordReportDialog &&
                    <UserDetailsRecordReportDialog
                        userId={this.props.userId}
                        handleClose={() => this.setState({ openUserDetailsRecordReportDialog: false })}
                    />
                }
            </div>
        )
    }
}